import { useState } from 'react'

import { useFetchLatestControllerConfiguration } from '@/features/controller/configuration/hooks/useLatestControllerConfiguration'
import type { ControllerConfigTypeId } from '@/features/controller/configuration/types'

/** After a save conflict, fetches the version saved meanwhile, so an edit can be rebased on it */
export function useFetchNewerVersion(controllerId: string) {
  const fetchLatestConfig = useFetchLatestControllerConfiguration()
  const [isFetchingNewerVersion, setIsFetchingNewerVersion] = useState(false)

  /** Resolves to null if the newer version could not be fetched */
  async function fetchNewerVersion(configTypeId: ControllerConfigTypeId) {
    setIsFetchingNewerVersion(true)
    return fetchLatestConfig({ controllerId, configTypeId })
      .catch(() => null)
      .finally(() => setIsFetchingNewerVersion(false))
  }

  return { fetchNewerVersion, isFetchingNewerVersion }
}
